import { Box, Button, Checkbox, Chip, Container, Paper, styled, TextField, Typography } from '@mui/material';
import React, { useState } from "react";
import product from './features-illustration-dark.svg';

import darkheader from './header-illustration-dark.svg';
import screenpic1 from './advertisement.png'

import screenpic3 from './dashboard.png'

import main from './main.png'
import dalle1o from './dalle1o.png'
import dalle2o from './dalleo2.png'
import dalle3o from './dalle3o.png'
import dalle4o from './dalle4o.png'
import { writeUserData } from './firebase.config';
import Cards from './BoxPopUp';
import ForwardIcon from '@mui/icons-material/Forward';
import axios from 'axios';
import { LinkedIn } from '@mui/icons-material';


const BoxSC = styled(Box)<{bgUrl:string, cover?:boolean,width?:string,bgPostion?:string,height?:string, alignItems?:string}>`
  position:relative;
  background-image:url(${(props)=> props.bgUrl});
  background-position: ${(props)=> props.bgPostion ?  props.bgPostion : 'center' };
  background-repeat: no-repeat;
  background-size:${(props)=> props.cover ? '100%' : 'cover'} ;
  display:flex;
  justify-content:${(props)=> props.alignItems ? props.alignItems : 'center'};
   align-items:center; 
   width:${(props)=> props.width ? props.width : '850px'}; 
   height:${(props)=> props.height ? props.height : '600px'};


   @media only screen and (max-width: 970px){
    width:95%; 
   height:500px;
  }

  @media only screen and (max-width: 500px){
    width:100%; 
   height:auto;
  }

  @media only screen and (max-width: 387px){
    background-size:${(props)=> props.cover ? '100%' : '80%'} ;
   }
  `

  const BoxSC2 = styled(Box)<{bgUrl?:string, cover?:boolean}>`
  background-image:url(${(props)=> props.bgUrl ? props.bgUrl : ''});
  background-position: top right;
  background-repeat: no-repeat;
  background-size:${(props)=> props.cover ? '100%' : ''} ;
  
  @media only screen and (max-width: 600px){
    
  .heading{
    font-size:10vw;
  }
  }

  @media only screen and (max-width: 446px){
    .btn{
      font-size:3vw;
    }

    .formWrapper{
      width:90%;
    }
   }


   @media only screen and (max-width: 387px){
    .btn{
      font-size:3vw;
    }
   }
  `

  const BoxConatiner = styled(Box)`
  display:flex;
   flex-direction:column;
  align-items:center;

  
  .advertPic{
    width:630px;
  }

  .dashboard{
    width:630px;
  }


  @media only screen and (max-width: 687px){

    .advert-wrapper{
      width:85%;
    }

    .advertPic{
      width:95%;
    }
    .dashboard{
      width:95%;
    }

    .productHeading{
      font-size:30px;
      margin:10px;
    }
  }
    @media only screen and (max-width: 440px){
      .productHeading{
        font-size:24px;
      }
    }

    
    @media only screen and (max-width: 930px){
    .aipics{
      display:flex;
      flex-direction:column;
      width:100%;
    }
    }
  }


  `

const LandingPage: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [url, setUrl] = useState<string>("");
  const [checked, isChecked] = useState<boolean>(false);
  const [sent, isSent] = useState<boolean>(false);
  
  
  

  const sendEmail = async () => {
    if (email !== "") { 
        writeUserData(email, url);
        setEmail('');
        setUrl('');
        isChecked(!checked);
        isSent(true);
  };
}

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  return (
    <Box width={'100%'} >
      <Box position={'absolute'} top={'10px'} right={'2%'}>
        <a href='https://www.linkedin.com/in/boris-vilhard-3babab1aa/'>
           <LinkedIn  fontSize='large'sx={{color:'white'}}/>
        </a>
        
      </Box>
     
    <BoxSC2  bgUrl={darkheader} cover>
 <Box position={'absolute'} left={'20px'} top={'20px'}>
        <Typography fontSize={'20px'} color={'black'} fontWeight={'bold'}>
          FNF
        </Typography>
        </Box>
     <Box height={'100vh'} display={'flex'}  alignItems={'center'}>
    <Container sx={{display:'flex',flexDirection:'column',alignItems:'center'}} maxWidth="sm" >
      <Chip sx={{backgroundColor:'white',fontWeight:'bold', border:'1px solid black'}} label={'COMMING SOON'} />
     
        <Typography className='heading' fontSize={'62px'} fontWeight={'bold'} gutterBottom>
         Advertise yourself and bring traffic with our solution!
        </Typography>
       <Box className={'formWrapper'} display={'flex'} width={'400px'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} >
        <TextField
          type="email"
          label="Email Address"
          variant="outlined"
          margin="normal"
          fullWidth
          value={email}
          onChange={handleInputChange}
        />
        <Box  display={'flex'} alignItems={'center'} width={'100%'}>
           <Checkbox checked={checked ? true : false} onChange={()=> isChecked(!checked)}/>
           <Box textAlign={'start'}>
        <Typography fontSize={'14px'} color={'gray'}>Get in contact with a founder to discuss potential software fit for your bussiness</Typography>
        </Box>
        </Box>
        {checked &&
         <TextField
          type="url"
          label="Your LinkedIn/Twitter/Instagram URL"
          variant="outlined"
          margin="normal"
          fullWidth
          value={url}
          onChange={(e)=> setUrl(e.target.value)}
        />
        }
        <Button  onClick={sendEmail}  fullWidth  sx={{backgroundColor:'black',marginTop:'20px'}}  variant='contained'>
         Join Waitlist
        </Button>
       
         <Typography fontSize={'16px'} color={'gray'}>
         The first 200 users will get 6 months for free!
        </Typography>
        {sent &&
         <Box marginTop={'20px'} borderRadius={'10px'} bgcolor={'#c2ffd2'} padding={'8px'} textAlign={'center'}>
          <Typography fontWeight={'bold'} color={'darkgreen'}>Successfuly joined the waitlist!</Typography>
          </Box>
        }
    </Box>
     
      
    
      </Container>
      
</Box>
</BoxSC2>

       <BoxConatiner>
        <Box>
        <Typography className='productHeading' variant='h4' fontWeight={'bold'}>Make your custom e-commerce page</Typography> 
       </Box>
              <BoxSC cover  bgUrl={product}>      
             <Cards/>

    </BoxSC>
      </BoxConatiner>
      
      
      <BoxConatiner marginTop={'150px'}>
         <Typography className='productHeading' variant='h4' fontWeight={'bold'}>Use advertising effectivly and easily</Typography>
         <Box className={'advert-wrapper'} borderRadius={'10px'} sx={{backgroundImage:"linear-gradient(to bottom, #212880, #393e98, #5055b0, #666cc8, #7c85e1)"}} padding={'25px'}  marginTop={'20px'} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} >     
    <Paper className='advertPic' sx={{margin:'30px 0'}}> 
      <img  width={'100%'} height={'auto'}  src={screenpic1} alt={''}  />
    </Paper>
    <Paper>
    <Box display={'flex'} flexDirection={'column'}>   
    <Typography className='productHeading' variant='h5' fontWeight={'bold'}>Boost advertisement design with AI</Typography>
      <Box className={'aipics'}  display={'flex'} margin={'20px 0'} alignItems={'center'}>
        <Box margin={'20px'}>
      <img  width={'auto'} height={130}  className='picture'  src={main} alt={''}  />
      </Box>
      <ForwardIcon fontSize='large'/>
      <img style={{marginRight:'10px'}}  width={180} height={'auto'}  className='picture'  src={dalle1o} alt={''}  />
      <img  style={{marginRight:'10px'}} width={180} height={'auto'}  className='picture'  src={dalle2o} alt={''}  />
      <img  style={{marginRight:'10px'}} width={180} height={'auto'}  className='picture'  src={dalle3o} alt={''}  />
      <img  style={{marginRight:'10px'}} width={180} height={'auto'}  className='picture'  src={dalle4o} alt={''}  />
     </Box>
   
    </Box>
    </Paper>
   </Box>
      </BoxConatiner>
      
    
      <BoxConatiner marginBottom={'120px'} marginTop={'120px'} >
        <Typography className='productHeading' variant='h4' fontWeight={'bold'}>Track your sales and ad peformance</Typography>
              <BoxSC cover  bgUrl={product}>          
    <Paper className='dashboard'>
      <img  alt={''} width={'100%'} height={'auto'}   src={screenpic3}  />
    </Paper>
    </BoxSC>
      </BoxConatiner>
  
    </Box>
  );
};

export default LandingPage;
